var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgArrowIndent = function SvgArrowIndent(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#000000",
    strokeWidth: 1.8
  }, /*#__PURE__*/React.createElement("line", {
    x1: 8.29411765,
    y1: 0.907311396,
    x2: 8.29411765,
    y2: 10.1,
    id: "Line",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.7058824,
    y1: 10.1,
    x2: 8.29411765,
    y2: 10.1,
    id: "Line",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.7058824,
    y1: 10.1,
    x2: 14.1764706,
    y2: 6.5,
    id: "Line",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.7058824,
    y1: 10.1,
    x2: 14.1764706,
    y2: 13.7,
    id: "Line",
    strokeLinecap: "square"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgArrowIndent);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow_indent.c8ec491f5a8173b69d086e614217b07d.svg";